export const MOTION_RIG_PRESETS={
  vergil: {
    hips:'root_hips_Armature', spine:'spine_lower_Armature', spine1:'spine_middle_Armature', spine2:'spine_upper_Armature',
    neck:'head_neck_middle_Armature', head:'head_neck_upper_Armature',
    leftshoulder:'arm_left_shoulder_1_Armature', leftarm:'arm_left_shoulder_2_Armature', leftforearm:'arm_left_elbow_Armature', lefthand:'arm_left_wrist_Armature',
    rightshoulder:'arm_right_shoulder_1_Armature', rightarm:'arm_right_shoulder_2_Armature', rightforearm:'arm_right_elbow_Armature', righthand:'arm_right_wrist_Armature',
    leftupleg:'leg_left_thigh_Armature', leftleg:'leg_left_knee_Armature', leftfoot:'leg_left_ankle_Armature', lefttoebase:'leg_left_toes_Armature',
    rightupleg:'leg_right_thigh_Armature', rightleg:'leg_right_knee_Armature', rightfoot:'leg_right_ankle_Armature', righttoebase:'leg_right_toes_Armature'
  },

  "queen": {
    "hips": "pelvis_04",
    "spine": "spine_01_05",
    "spine1": "spine_02_06",
    "spine2": "spine_03_07",
    "neck": "neck_01_099",
    "head": "head_0100",
    "leftshoulder": "clavicle_l_08",
    "leftarm": "upperarm_l_09",
    "leftforearm": "lowerarm_l_010",
    "lefthand": "hand_l_011",
    "rightshoulder": "clavicle_r_055",
    "rightarm": "upperarm_r_056",
    "rightforearm": "lowerarm_r_057",
    "righthand": "hand_r_058",
    "leftupleg": "thigh_l_0101",
    "leftleg": "calf_l_0102",
    "leftfoot": "foot_l_0103",
    "lefttoebase": "ball_l_0104",
    "rightupleg": "thigh_r_0105",
    "rightleg": "calf_r_0106",
    "rightfoot": "foot_r_0107",
    "righttoebase": "ball_r_0108",
    "lefthandthumb1": "thumb_01_l_024",
    "lefthandthumb2": "thumb_02_l_025",
    "lefthandthumb3": "thumb_03_l_026",
    "lefthandindex1": "index_01_l_012",
    "lefthandindex2": "index_02_l_013",
    "lefthandindex3": "index_03_l_014",
    "lefthandmiddle1": "middle_01_l_015",
    "lefthandmiddle2": "middle_02_l_016",
    "lefthandmiddle3": "middle_03_l_017",
    "lefthandring1": "ring_01_l_021",
    "lefthandring2": "ring_02_l_022",
    "lefthandring3": "ring_03_l_023",
    "lefthandpinky1": "pinky_01_l_018",
    "lefthandpinky2": "pinky_02_l_019",
    "lefthandpinky3": "pinky_03_l_020",
    "righthandthumb1": "thumb_01_r_071",
    "righthandthumb2": "thumb_02_r_072",
    "righthandthumb3": "thumb_03_r_073",
    "righthandindex1": "index_01_r_059",
    "righthandindex2": "index_02_r_060",
    "righthandindex3": "index_03_r_061",
    "righthandmiddle1": "middle_01_r_062",
    "righthandmiddle2": "middle_02_r_063",
    "righthandmiddle3": "middle_03_r_064",
    "righthandring1": "ring_01_r_068",
    "righthandring2": "ring_02_r_069",
    "righthandring3": "ring_03_r_070",
    "righthandpinky1": "pinky_01_r_065",
    "righthandpinky2": "pinky_02_r_066",
    "righthandpinky3": "pinky_03_r_067"
  },
  "samurai": {
    "hips": "CATRigHub001_01",
    "spine": "CATRigSpine1_011",
    "spine1": "CATRigSpine2_012",
    "spine2": "CATRigHub002_013",
    "neck": "CATRigSpine1_014",
    "head": "CATRigHub003_015",
    "leftshoulder": "CATRigLArmCollarbone_022",
    "leftarm": "CATRigLArm1_023",
    "leftforearm": "CATRigLArm2_024",
    "lefthand": "CATRigLArmPalm_025",
    "rightshoulder": "CATRigRArmCollarbone_042",
    "rightarm": "CATRigRArm1_043",
    "rightforearm": "CATRigRArm2_044",
    "righthand": "CATRigRArmPalm_045",
    "leftupleg": "CATRigLLeg1_02",
    "leftleg": "CATRigLLeg2_03",
    "leftfoot": "CATRigLLegAnkle_04",
    "lefttoebase": "CATRigLLegDigit11_05",
    "rightupleg": "CATRigRLeg1_06",
    "rightleg": "CATRigRLeg2_07",
    "rightfoot": "CATRigRLegAnkle_08",
    "righttoebase": "CATRigRLegDigit11_09",
    "lefthandthumb1": "CATRigLArmDigit11_026",
    "lefthandthumb2": "CATRigLArmDigit12_027",
    "lefthandthumb3": "CATRigLArmDigit13_028",
    "lefthandindex1": "CATRigLArmDigit21_029",
    "lefthandindex2": "CATRigLArmDigit22_030",
    "lefthandindex3": "CATRigLArmDigit23_031",
    "lefthandmiddle1": "CATRigLArmDigit31_032",
    "lefthandmiddle2": "CATRigLArmDigit32_033",
    "lefthandmiddle3": "CATRigLArmDigit33_034",
    "lefthandring1": "CATRigLArmDigit41_035",
    "lefthandring2": "CATRigLArmDigit42_036",
    "lefthandring3": "CATRigLArmDigit43_037",
    "lefthandpinky1": "CATRigLArmDigit51_038",
    "lefthandpinky2": "CATRigLArmDigit52_039",
    "lefthandpinky3": "CATRigLArmDigit53_040",
    "righthandthumb1": "CATRigRArmDigit11_046",
    "righthandthumb2": "CATRigRArmDigit12_047",
    "righthandthumb3": "CATRigRArmDigit13_048",
    "righthandindex1": "CATRigRArmDigit21_049",
    "righthandindex2": "CATRigRArmDigit22_050",
    "righthandindex3": "CATRigRArmDigit23_051",
    "righthandmiddle1": "CATRigRArmDigit31_052",
    "righthandmiddle2": "CATRigRArmDigit32_053",
    "righthandmiddle3": "CATRigRArmDigit33_054",
    "righthandring1": "CATRigRArmDigit41_055",
    "righthandring2": "CATRigRArmDigit42_056",
    "righthandring3": "CATRigRArmDigit43_057",
    "righthandpinky1": "CATRigRArmDigit51_058",
    "righthandpinky2": "CATRigRArmDigit52_059",
    "righthandpinky3": "CATRigRArmDigit53_060"
  },
  "mage": {
    "hips": "CC_Base_Hip_03",
    "spine": "CC_Base_Waist_035",
    "spine1": "CC_Base_Spine01_036",
    "spine2": "CC_Base_Spine02_037",
    "neck": "CC_Base_NeckTwist01_038",
    "head": "CC_Base_Head_040",
    "leftshoulder": "CC_Base_L_Clavicle_051",
    "leftarm": "CC_Base_L_Upperarm_052",
    "leftforearm": "CC_Base_L_Forearm_053",
    "lefthand": "CC_Base_L_Hand_057",
    "rightshoulder": "CC_Base_R_Clavicle_079",
    "rightarm": "CC_Base_R_Upperarm_080",
    "rightforearm": "CC_Base_R_Forearm_081",
    "righthand": "CC_Base_R_Hand_085",
    "leftupleg": "CC_Base_L_Thigh_05",
    "leftleg": "CC_Base_L_Calf_06",
    "leftfoot": "CC_Base_L_Foot_07",
    "lefttoebase": "CC_Base_L_ToeBase_09",
    "rightupleg": "CC_Base_R_Thigh_020",
    "rightleg": "CC_Base_R_Calf_021",
    "rightfoot": "CC_Base_R_Foot_023",
    "righttoebase": "CC_Base_R_ToeBase_024",
    "lefthandthumb1": "CC_Base_L_Thumb1_070",
    "lefthandthumb2": "CC_Base_L_Thumb2_071",
    "lefthandthumb3": "CC_Base_L_Thumb3_072",
    "lefthandindex1": "CC_Base_L_Index1_067",
    "lefthandindex2": "CC_Base_L_Index2_068",
    "lefthandindex3": "CC_Base_L_Index3_069",
    "lefthandring1": "CC_Base_L_Ring1_061",
    "lefthandring2": "CC_Base_L_Ring2_062",
    "lefthandring3": "CC_Base_L_Ring3_063",
    "lefthandpinky1": "CC_Base_L_Pinky1_058",
    "lefthandpinky2": "CC_Base_L_Pinky2_059",
    "lefthandpinky3": "CC_Base_L_Pinky3_060",
    "righthandthumb1": "CC_Base_R_Thumb1_092",
    "righthandthumb2": "CC_Base_R_Thumb2_093",
    "righthandthumb3": "CC_Base_R_Thumb3_094",
    "righthandindex1": "CC_Base_R_Index1_095",
    "righthandindex2": "CC_Base_R_Index2_096",
    "righthandindex3": "CC_Base_R_Index3_097",
    "righthandring1": "CC_Base_R_Ring1_086",
    "righthandring2": "CC_Base_R_Ring2_087",
    "righthandring3": "CC_Base_R_Ring3_088",
    "righthandpinky1": "CC_Base_R_Pinky1_098",
    "righthandpinky2": "CC_Base_R_Pinky2_099",
    "righthandpinky3": "CC_Base_R_Pinky3_0100"
  }
};
